/* tslint:disable:triple-equals */
import { ChangeDetectorRef, Component, Inject, Input, OnInit } from '@angular/core';
import { MedReviewService } from '../../services/med-review.service';
import { GeneralInputDialogComponent } from '../../../../partials/content/crud';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';

export enum CARDS_STATUSES {
  STARTED = 'NEW',
  CHANGED = 'CHANGED',
  RENEWED = 'RENEWED',
  NOT_PRESCRIBER_OR_DISCONTINUED = 'DISCONTINUED',
}

@Component({
  selector: 'kt-med-review-board-body',
  templateUrl: './med-review-board-body.component.html',
  styleUrls: ['./med-review-board-body.component.scss'],
})
export class MedReviewBoardBodyComponent implements OnInit {
  constructor(
    private medReviewService: MedReviewService,
    private cdr: ChangeDetectorRef,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
  ) {}
  medTypeFilter = '';

  @Input() inputData;
  fromPatient;
  data;
  medReviewStatuses = {
    started: 'Started',
    changed: 'Changed',
    renewed: 'Renewed',
    notPrescribedOrDiscontinued: 'Active or Discontinued',
  };

  statusesKeys = ['started', 'changed', 'renewed', 'notPrescribedOrDiscontinued'];

  statusData = {
    started: [],
    changed: [],
    renewed: [],
    notPrescribedOrDiscontinued: [],
  };
  foods = [
    { value: 'steak-0', viewValue: 'Steak' },
    { value: 'pizza-1', viewValue: 'Pizza' },
    { value: 'tacos-2', viewValue: 'Tacos' },
  ];

  ngOnInit(): void {
    this.data =
      this.dialogData && Object.keys(this.dialogData).length ? this.dialogData : this.inputData;
    this.fromPatient = (this.dialogData && Object.keys(this.dialogData).length) > 0;
    this.updateBoard();
    this.medReviewService.getPatientMedReviewFilter().subscribe((value) => {
      this.medTypeFilter = value;
      this.cdr.detectChanges();
    });
  }

  updateBoard() {
    this.statusData = {
      started: [],
      changed: [],
      renewed: [],
      notPrescribedOrDiscontinued: [],
    };
    for (const card of this.data?.medications) {
      if (card.med_review_id != this.data.id) {
        if (card.classification != CARDS_STATUSES.NOT_PRESCRIBER_OR_DISCONTINUED)
          this.statusData.notPrescribedOrDiscontinued.push(card);
        continue;
      }
      switch (card.classification) {
        case CARDS_STATUSES.STARTED:
          this.statusData.started.push(card);
          break;
        case CARDS_STATUSES.RENEWED:
          this.statusData.renewed.push(card);
          break;
        case CARDS_STATUSES.CHANGED:
          this.statusData.changed.push(card);
          break;
        case CARDS_STATUSES.NOT_PRESCRIBER_OR_DISCONTINUED:
          this.statusData.notPrescribedOrDiscontinued.push(card);
          break;
      }
    }
  }

  getCardClass(statusKey: string) {
    switch (statusKey) {
      case CARDS_STATUSES.CHANGED:
      case this.statusesKeys[2]:
        return 'bg-orange';
      case CARDS_STATUSES.STARTED:
      case this.statusesKeys[0]:
        return 'bg-green';
      case CARDS_STATUSES.RENEWED:
      case this.statusesKeys[1]:
        return 'bg-blue';
      case CARDS_STATUSES.NOT_PRESCRIBER_OR_DISCONTINUED:
      case this.statusesKeys[3]:
        return 'bg-grey';
    }
  }

  getDrugDetails(treatment: any) {
    if (treatment && treatment.prescription && treatment.prescription.drug) {
      const prescription = treatment.prescription;
      return `<div>${prescription.drug.drug} <b>${prescription.drug.strength}
                    ${prescription.drug.unit}</b> ${treatment.drug_form}</div>`;
    }
  }

  getHoa(treatment: any, tooltip = false) {
    if (treatment && treatment.prescription && treatment.prescription.drug) {
      const hoa = treatment.hoa.split(',');
      const res = `<div>m: <b>${hoa[0]}</b>   n: <b>${hoa[1]}</b>   e: <b>${hoa[2]}</b>   b: <b>${hoa[3]}</b></div>`;
      if (tooltip) {
        return res
          .replace(new RegExp('<div>', 'g'), '')
          .replace(new RegExp('<b>', 'g'), '')
          .replace(new RegExp('</b>', 'g'), '')
          .replace(new RegExp('</div>', 'g'), '');
      }
      return res;
    }
  }

  getBadges(card: any) {
    let res = '';

    const status = card.type_of_change_string ? card.type_of_change_string.split(',') : [];
    for (let x of status) {
      x = x.trim();
      if (
        card.med_review_id == this.data.id &&
        (['NTS', 'FREQ', 'DOSE', 'HOA', 'RES', 'REC'].indexOf(x) > -1 ||
          (card.classification == 'NEW' && x == 'NTS'))
      )
        res += this.medReviewService.getIndicators([x]);
    }
    return res;
  }

  moveToDiscontinued(card: any) {
    const generalDialog = this.dialog.open(GeneralInputDialogComponent, {
      data: { title: 'Discontinued Note', btnTitle: 'Discontinue', name: null, labelText: 'Note' },
      width: '440px',
    });
    generalDialog.afterClosed().subscribe((result) => {
      if (!result) return;
      card.disabled = true;
      const body = {
        office: card.office_id || '0',
        rxno: card.rxno || '0',
        note: result,
      };
      this.medReviewService.moveMedicationToDiscontinued(card.id, body).subscribe(() => {
        card.disabled = false;
        card.classification = CARDS_STATUSES.NOT_PRESCRIBER_OR_DISCONTINUED;
        card.status = 0;
        this.updateBoard();
        this.cdr.detectChanges();
      });
    });
  }

  showCardForMedType(card: any) {
    return (
      card?.type &&
      (this.medTypeFilter.localeCompare('C') === 0
        ? card.type.indexOf('C') > -1
        : this.medTypeFilter.localeCompare('!C') === 0
        ? card.type.indexOf('C') < 0
        : true)
    );
  }
}
